<template>
  <div class="recent-magazines-section">
    <home-section-header title="صدر حديثاً" route-name="ZadiMagazines" />
    <magazine-card-wrapper :recent-magazines="recentMagazines" :is-loading-magazines="isLoadingRecentMagazines" />
  </div>
</template>

<script>
import MagazineCardWrapper from "../magazines/MagazineCardWrapper.vue";
import HomeSectionHeader from "../shared/HomeSectionHeader.vue";
import magazinesRepository from "../../repositories/magazinesRepository";

export default {
  components: { MagazineCardWrapper, HomeSectionHeader },
  data() {
    return {
      recentMagazines: null,
      isLoadingRecentMagazines: false,
    }
  },
  async mounted() {
    this.isLoadingRecentMagazines = true;
    const res = await magazinesRepository.getRecentMagazines();
    this.recentMagazines = await res?.data?.data;
    this.isLoadingRecentMagazines = false;
  }
};
</script>

<style scoped>
.recent-magazines-section {
  padding: 120px 0px 0px 0px;
  background:
    url("../../../../../public/assets/images/website/zadi/bg-book-1.png") center top 0px no-repeat;
  background-size: 130px;
}

@media (max-width: 560px) {
  .recent-magazines-section {
    padding: 60px 0px 0px 0px;
    background: unset;
  }
}
</style>